import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxMaskModule } from 'ngx-mask';
import { CollapsibleCardModule } from '../../shared/components/collapsible-card/collapsible-card.module';
import { DividerComponent } from '../../shared/components/divider';
import { LoaderComponent } from '../../shared/components/loader';
import { HeaderModule } from '../../shared/header/header.module';
import { MaterialModule } from '../../shared/material.module';
import { SharedPipesModule } from '../../shared/pipes';
import { SchoolAddressInformationComponent } from '../school-address-information/school-address-information.component';
import { SchoolContactInformationComponent } from '../school-contact-information/school-contact-information.component';
import { SchoolDisbursementInformationComponent } from '../school-disbursement-information/school-disbursement-information.component';
import { SchoolGeneralInformationComponent } from '../school-general-information/school-general-information.component';
import { SchoolCardComponent } from './school-card.component';
@NgModule({
  declarations: [
    SchoolCardComponent,
    SchoolAddressInformationComponent,
    SchoolGeneralInformationComponent,
    SchoolContactInformationComponent,
    SchoolDisbursementInformationComponent
  ],
  imports: [
    CommonModule,
    CollapsibleCardModule,
    MaterialModule,
    RouterModule,
    HeaderModule,
    LoaderComponent,
    DividerComponent,
    ReactiveFormsModule,
    SharedPipesModule,
    NgxMaskModule,

  ],
  exports: [
    SchoolCardComponent,
    SchoolAddressInformationComponent,
    SchoolGeneralInformationComponent,
    SchoolContactInformationComponent,
    SchoolDisbursementInformationComponent
  ]
})
export class SchoolCardModule {}
